import {ActivationComponent} from '@common_libraries/controls/activation/activation.component';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ActivationComponent as ActivationComponent_1 } from '../../../../../common_libraries/controls/activation/activation.component';


@Component({
    selector: 'app-activation',
    templateUrl: './accountActivation.component.html',
    standalone: true,
    imports: [ActivationComponent_1]
})

export class AccountActivationComponent implements OnInit {

    constructor() {  }

    ngOnInit() {
    }
}